import { CartProductDto } from '../../dto/cartProduct.dto';
import { DiscountTypeDto } from '../../dto/discountType.dto';
import { ServiceChargeDto } from '../../dto/serviceCharge.dto';

export interface PosManagerPinDialogResult {
  isManagerPin: boolean;
  managerEmployeeId: number;
  cartProduct?: CartProductDto;
  saleUnitCartId?: number;
  saleUnitCartSplitId?: number;
  merchantId?: number;
  cartProducts?: CartProductDto[];
  discountType?: DiscountTypeDto;
  serviceCharge?: ServiceChargeDto;
}
